import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class OfflineVoucherAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Business';
  controllerName = 'OfflineVouchers';

  /**
   * Lấy dữ liệu
   * @param {*} param
   * @returns
   */
  getVouchersOffline(param) {
    let request = {
      url: this.getAPIUrl() + '/GetVoucherOffline',
      data: param,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lưu chứng từ offline vào bảng offline_voucher
   */
  saveData(param) {
    let request = {
      url: this.getAPIUrl() + '/save',
      data: param,
    };
    return this.postAsync(request);
  }

  /**
   * Xử lý đồng bộ dữ liệu lên server
   */
  synchronyData(param) {
    let request = {
      url: this.getAPIUrl() + '/synchronyData',
      data: param,
    };
    return this.postAsync(request);
  }
}

export default new OfflineVoucherAPI();
